export enum GridID {
  CLIENT = 'portal.client-overview',
  UPLOAD = 'portal.uploaded-files',
  CREDIT = 'portal.payments',
  CREDIT_RECENT = 'portal.credit-recenttransfers',
  CREDIT_DELETED = 'portal.credit-deletedtransfers',
  TEMPLATE = 'portal.from-template',
  LOGS = 'portal.logs-overview',
  LOG_DETAILS = 'portal.log-details',
  USER_MGMT = 'portal.user-mngmt',
  USER_MGMT_ACCOUNT = 'portal.usermngmtaccount-overview',
  PAYMENTS_TRANSACTIONS = 'portal.transactions-payments',
  TRANSACTIONS = 'portal.ars-transactions',
  ACCOUNTS = 'portal.ars-accounts',
  VALUE_SERIES = 'portal.ars-valueSeries',
  DLC_DOCUMENTS = 'portal.dlc-overview',
  USERGROUPS = 'portal.usergroups',
  USERGROUPVIEW = 'portal.usergroups-view',
  PENDING_APPROVALS = 'portal.pending-approvals',
  PENDING_APPROVAL_DETAILS = 'portal.pending-approval-details',
  DOWNTIME_NOTIFICATIONS = 'portal.downtime-notifications',
  USER_MGMT_USER_GROUPS_VIEW = 'portal.user-mgmt-user-groups-view',
}
